import { render, staticRenderFns } from "./courierDeliveryList.vue?vue&type=template&id=d7e287fc&scoped=true&"
import script from "./courierDeliveryList.vue?vue&type=script&lang=js&"
export * from "./courierDeliveryList.vue?vue&type=script&lang=js&"
import style0 from "./courierDeliveryList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7e287fc",
  null
  
)

component.options.__file = "courierDeliveryList.vue"
export default component.exports